import axios from 'axios';
import * as Sentry from "@sentry/vue";

export default {
    fetchAll(farm, date) {
        const options = {
            method: 'get',
            url: `/umbraco/api/HSEvents/get?farm=${farm}&date=${date}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchSingle(id) {

        const options = {
            method: 'get',
            url: `/umbraco/api/HSEvents/getsingle?id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchSingleReadOnly(id) {

        const options = {
            method: 'get',
            url: `/umbraco/api/HSEvents/GetDetailReadyOnly?id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchImage(id) {

        const options = {
            method: 'get',
            url: `/umbraco/api/HSEvents/getimage?id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    completeAction(id, actionDoneToComplete) {
        const options = {
            method: 'put',
            url: `/umbraco/api/HSEvents/completeaction?id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: {
                actionDoneToComplete: actionDoneToComplete
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    delete(id) {

        const options = {
            method: 'delete',
            url: `/umbraco/api/HSEvents/delete?id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    deleteImage(id) {

        const options = {
            method: 'delete',
            url: `/umbraco/api/HSEvents/deleteImage?id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    add(conversation) {

        const options = {
            method: 'post',
            url: `/umbraco/api/HSEvents/Add`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: conversation
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    update(conversation) {

        const options = {
            method: 'put',
            url: `/umbraco/api/HSEvents/Update`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: conversation
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    uploadImage(image, conversationId) {

        const options = {
            method: 'post',
            url: `/umbraco/api/HSEvents/UploadImage?id=${conversationId}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: image
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    }

}